import type { DimCatalogRow } from '~/api/endpoints/catalog'

/**
 * FU-m-2: the offered group-by dims a sibling DRIVER fact cannot carry — exactly the set the walk
 * reports as `dims:{<dim>:null}` (the typed DimNotApplicableError trigger). Pure + local: the dim
 * catalog is the authoritative per-fact dim membership. A driver fact with NO catalog rows (or an
 * unloaded catalog) is NOT treated as a constraint, so nothing is marked until membership is known.
 */
export function computeBreakerDims(
  availableDims: string[],
  driverFacts: string[],
  dimCatalogRows: DimCatalogRow[],
): Set<string> {
  if (driverFacts.length === 0) return new Set()
  const dimsByFact = new Map<string, Set<string>>()
  for (const r of dimCatalogRows) {
    let set = dimsByFact.get(r.fact_table)
    if (!set) {
      set = new Set()
      dimsByFact.set(r.fact_table, set)
    }
    set.add(r.dim_name)
  }
  const breakers = new Set<string>()
  for (const dim of availableDims) {
    for (const fact of driverFacts) {
      const factDims = dimsByFact.get(fact)
      // `size === 0` is defensive: a fact present in the map always has ≥1 dim given how the map is
      // populated, but the guard future-proofs against refactors that might insert an empty set.
      if (!factDims || factDims.size === 0) continue // unknown membership → not a constraint
      if (!factDims.has(dim)) {
        breakers.add(dim)
        break
      }
    }
  }
  return breakers
}
